/* eslint-disable eag/match-named-export -- Pre-existing grab-bag file with several exports */
import {openDialog} from 'platform/components';

import {UserAbsenceResponseBody} from '@dms/api/shared';
import i18n from '@dms/i18n';

import {RequiredTestIdProps} from 'shared/web';

import {UserAbsenceFormDialog} from '../components/UserAbsenceFormDialog';

interface OpenCreateUserAbsenceDialogParams extends RequiredTestIdProps {
  userId: string;
  onSuccess?: () => void;
}

interface OpenEditUserAbsenceDialogParams extends OpenCreateUserAbsenceDialogParams {
  absence: UserAbsenceResponseBody;
}

export function openCreateUserAbsenceDialog(params: OpenCreateUserAbsenceDialogParams) {
  openDialog(<UserAbsenceFormDialog {...params} />, {
    title: `${i18n.t('general.actions.add')} ${i18n.t('user.awayStatus.awayBadge')}`,
  });
}

export function openEditUserAbsenceDialog(params: OpenEditUserAbsenceDialogParams) {
  openDialog(<UserAbsenceFormDialog {...params} />, {
    title: `${i18n.t('general.actions.edit')} ${i18n.t('user.awayStatus.awayBadge')}`,
  });
}
